/* eslint-disable  @angular-eslint/prefer-on-push-component-change-detection */
import { Component, ComponentRef, ViewChild, inject } from '@angular/core';
import { DrawerComponent as AppkitDrawerComponent } from '@appkit4/angular-components/drawer';
import { Drawer } from '@shared/abstraction/drawer/drawer';
import { DrawerBody } from '@shared/abstraction/drawer/drawer-body';
import { ContainerDirective } from '@shared/directives/container.directive';
import { DrawerManagerService } from '@shared/services/drawer/drawer-manager.service';

@Component({
  standalone: false,
  selector: 'gstar-drawer',
  templateUrl: './drawer.component.html',
})
export class DrawerComponent {
  private readonly drawerManagerService = inject(DrawerManagerService);

  settings?: Drawer;
  isVisible: boolean = false;

  @ViewChild(ContainerDirective, { static: false })
  container!: ContainerDirective;
  @ViewChild('drawer', { static: false }) drawer!: AppkitDrawerComponent;

  constructor() {
    this.drawerManagerService.trigger.subscribe((setting: Drawer) =>
      this.openDrawer(setting)
    );

    this.drawerManagerService.closeDrawer.subscribe(() => this.close());
  }

  get title(): string {
    return this.settings ? this.settings.title : '';
  }

  get primaryLabelButton(): string {
    return this.settings && this.settings.primaryButton
      ? this.settings.primaryButton.label
      : '';
  }

  get primaryIconButton(): string {
    return this.settings &&
      this.settings.primaryButton &&
      this.settings.primaryButton.icon
      ? this.settings.primaryButton.icon
      : '';
  }

  get secondaryLabelButton(): string {
    return this.settings && this.settings.secondaryButton
      ? this.settings.secondaryButton.label
      : '';
  }

  get secondaryIconButton(): string {
    return this.settings &&
      this.settings.secondaryButton &&
      this.settings.secondaryButton.icon
      ? this.settings.secondaryButton.icon
      : '';
  }

  get closable(): boolean {
    return !(this.settings && this.settings.hideCloseButton);
  }

  get hideButton(): boolean {
    return !(this.settings && this.settings.hideFooterButtons);
  }

  get mask(): boolean {
    return !!(this.settings && this.settings.mask);
  }

  get primaryButtonDisabled(): boolean {
    return !!(
      this.settings &&
      this.settings.primaryButton &&
      this.settings.primaryButton.disabled
    );
  }

  closeHandler(_id: string): void {
    this.settings?.close.next();
  }

  primaryHandler(): void {
    this.isVisible = false;
    if (this.settings) {
      this.settings.primaryHandler.next();
    }
  }

  secondaryHandler(): void {
    this.isVisible = false;
    if (this.settings) {
      this.settings.secondaryHandler.next();
    }
  }

  close(): void {
    this.isVisible = false;
  }

  private openDrawer(settings: Drawer): void {
    this.settings = settings;
    if (this.settings && this.settings.component && this.container) {
      this.container.viewContainerRef.clear();
      const component: ComponentRef<DrawerBody> =
        this.container.viewContainerRef.createComponent(
          this.settings.component
        );
      component.instance.setting = this.settings;
      component.instance.drawerPanel = this;
    }
    this.isVisible = true;
  }
}
